import React from 'react';
import { LayoutDashboard, Users, Calendar, BarChart3, Settings } from 'lucide-react';
interface SidebarProps {
  currentPage?: string;
  onNavigate?: (page: string) => void;
}
const navItems = [{
  icon: LayoutDashboard,
  label: 'Home',
  page: 'home'
}, {
  icon: Users,
  label: 'Kontakte',
  page: 'contacts'
}, {
  icon: BarChart3,
  label: 'KPI Tracker',
  page: 'kpi'
}, {
  icon: Calendar,
  label: 'Kalender',
  page: 'calendar'
}, {
  icon: Settings,
  label: 'Einstellungen',
  page: 'settings'
}];
export function Sidebar({
  currentPage = 'contacts',
  onNavigate
}: SidebarProps) {
  return <aside className="w-16 border-r border-border bg-card flex flex-col items-center py-4" data-id="element-146">
      <div className="mb-8" data-id="element-147">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/n9wewYGMjUg62LB8s4ZaRK/Download.png" alt="Logo" className="h-10 w-10 rounded-lg" data-id="element-148" />
      </div>

      <nav className="flex-1 flex flex-col items-center gap-2" data-id="element-149">
        {navItems.map(item => <button key={item.label} onClick={() => onNavigate?.(item.page)} className={`h-10 w-10 rounded-lg flex items-center justify-center transition-colors ${currentPage === item.page ? 'bg-primary text-primary-foreground' : 'text-muted-foreground hover:bg-accent hover:text-accent-foreground'}`} title={item.label} data-id="element-150">
            <item.icon className="h-5 w-5" data-id="element-151" />
          </button>)}
      </nav>
    </aside>;
}